import { useState } from 'react';
import { FeatureFlag } from '@mews-commander/enums';
import { SidePanel } from '@mews/b2b-ui';
import { BusinessError, lt, useFeatureFlag } from '@mews/framework';
import { Tab, Tabs } from '@optimus-web/core';
import { useReservationContracts } from '../hooks/useReservationContracts';
import { useDocumentsTableContext } from '../DocumentsTableContext';
import { DocumentDetailsTab } from './DocumentDetailsTab';

enum DocumentDetailsTabValue {
    Details = 'details',
    ActionLog = 'actionLog',
}

interface DocumentsDetailsDialogProps {
    isActive: boolean;
    onClose: () => void;
    documentId: string;
}

export const DocumentDetailsDialog = ({ isActive, onClose, documentId }: DocumentsDetailsDialogProps) => {
    const [activeTab, setActiveTab] = useState<DocumentDetailsTabValue>(DocumentDetailsTabValue.Details);
    const isContractingActionLogsEnabled = useFeatureFlag(FeatureFlag.contractingActionLogsEnabled);
    const { groupId, reservationId } = useDocumentsTableContext();
    const contracts = useReservationContracts({ groupId, reservationId });
    const contract = contracts?.find((c) => c.id === documentId);

    if (isActive && contract == null) {
        throw new BusinessError('Contract not found');
    }

    return (
        <SidePanel
            width="small"
            opened={isActive}
            onClose={onClose}
            title={contract?.name}
            headerActions={null}
            content={
                <>
                    {isContractingActionLogsEnabled && (
                        <Tabs
                            activeTabValue={activeTab}
                            inline
                            onTabClick={(_, value) => setActiveTab(value as DocumentDetailsTabValue)}
                            showDivider
                        >
                            <Tab
                                id={DocumentDetailsTabValue.Details}
                                label={lt('DetailPlural')}
                                value={DocumentDetailsTabValue.Details}
                            />
                        </Tabs>
                    )}

                    {activeTab === DocumentDetailsTabValue.Details && contract != null && (
                        <DocumentDetailsTab contract={contract} />
                    )}
                </>
            }
        />
    );
};
